import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { TRADEMASTER__MUTATIONS } from "../mutation-types";
import { TRADEMASTER__ACTIONS } from "../action-types";
import { TRADEMASTER__API } from "@/_helpers/urls";

// State
const state = {
  managers: [],
  investorstatistics: null,
  investorclients: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TRADEMASTER__MUTATIONS.GETALLMANAGER](state, data) {
    state.managers = data;
  },
  [TRADEMASTER__MUTATIONS.GETRADEMASTERINVESTORSTATISTICS](state, data) {
    state.investorstatistics = data;
  },
  [TRADEMASTER__MUTATIONS.GETINVESTORCLIENTS](state, data) {
    state.investorclients = data;
  },
};

// Actions
const actions = {
  async [TRADEMASTER__ACTIONS.GETALLMANAGER]({ commit }) {
    try {
      const response = await HTTP().get(TRADEMASTER__API.GETALLMANAGER);
      commit(TRADEMASTER__MUTATIONS.GETALLMANAGER, response.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  async [TRADEMASTER__ACTIONS.GETRADEMASTERINVESTORSTATISTICS](
    { commit },
    parameters
  ) {
    try {
      const response = await HTTP().post(
        TRADEMASTER__API.GETRADEMASTERINVESTORSTATISTICS,
        parameters
      );

      if (response.status === 200) {
        commit(
          TRADEMASTER__MUTATIONS.GETRADEMASTERINVESTORSTATISTICS,
          response.data
        );
      } else {
        commit(TRADEMASTER__MUTATIONS.GETRADEMASTERINVESTORSTATISTICS, []);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [TRADEMASTER__ACTIONS.GETINVESTORCLIENTS]({ commit }, parameters) {
    try {
      const response = await HTTP().post(
        TRADEMASTER__API.GETINVESTORCLIENTS,
        parameters
      );

      if (response.status === 200) {
        commit(TRADEMASTER__MUTATIONS.GETINVESTORCLIENTS, response.data);
      } else {
        commit(TRADEMASTER__MUTATIONS.GETINVESTORCLIENTS, []);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [TRADEMASTER__ACTIONS.CHANGEINVESTORSTATUS]({ dispatch }, parameter) {
    try {
      const url = `${TRADEMASTER__API.CHANGEINVESTORSTATUS}`;
      const response = await HTTP().post(url, parameter);
      if (response.status === 200) {
        toast.success(response.data.message);
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update");
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
